import React, { useState, useEffect, useContext } from "react";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import AddEditCustomer from "./AddEditCustomer";
import { FilterMatchMode } from "primereact/api";
import LoadingOverlay from "react-loading-overlay";
import { Triangle } from "react-loader-spinner";
import { InputText } from "primereact/inputtext";
import { handleGetRequest } from "../../services/GetTemplate";
import { useDispatch } from "react-redux";
import { Divider } from "primereact/divider";
import { handleDeleteRequest } from "../../services/DeleteTemplate";
import { confirmDialog } from "primereact/confirmdialog";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import deleteIcon from "../../assets/farmkar_assets/Png/delete.png";
import editIcon from "../../assets/farmkar_assets/Png/edit.png";
import viewIcon from "../../assets/farmkar_assets/Png/view.png";
import CustomDeleteDialog from "../../components/CustomDeleteDialog";
import { baseURL } from "../../Config";
import { Image } from "primereact/image";
import { Tag } from "primereact/tag";
import { Calendar } from "primereact/calendar";
import * as XLSX from "xlsx";
import moment from "moment";

const CustomerManagement = () => {
    const history = useHistory();
    const dispatch = useDispatch();

    const [isActive, setIsActive] = useState(false);
    const [userRowData, setUserRowData] = useState();
    const [addEditUser, setAddEditUser] = useState(false);
    const [allUsers, setAllUsers] = useState([]);
    const [displayDialog, setDisplayDialog] = useState(false);
    const [viewDisable, setViewDisable] = useState(false);
    const [referral, setReferral] = useState(false);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [referralText, setReferralText] = useState("");
    const [globalFilterValue, setGlobalFilterValue] = useState("");
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });

    // Pagination states
    const [loading, setLoading] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const [isSearchMode, setIsSearchMode] = useState(false);

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters["global"].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const actionTemplate = (rowData) => {
        return (
            <div className="">
                <Button className="edit-icon ml-2" onClick={() => handleEditUsers(rowData)}>
                    <img src={editIcon} alt="Edit" />
                </Button>
                <Button className="del-icon" onClick={() => confirm(rowData)}>
                    <img src={deleteIcon} alt="Delete" />
                </Button>
            </div>
        );
    };

    const confirm = (rowData) => {
        const acceptAction = () => handleDeleteUser(rowData);
        confirmDialog({
            message: <CustomDeleteDialog message="Are you sure you want to delete this user?" acceptAction={acceptAction} />,
            header: "Confirmation",
            accept: acceptAction,
            reject: null,
            draggable: false,
            resizable: false,
        });
    };

    const handleDeleteUser = async (rowData) => {
        setIsActive(true);
        const response = await dispatch(handleDeleteRequest(`/api/v1/farmer/delete/${rowData?.id}`, true, true));
        if (response) {
            await getCustomersList();
        }
        setIsActive(false);
    };

    const handleEditUsers = (rowData) => {
        setDisplayDialog(true);
        setAddEditUser(true);
        setUserRowData(rowData);
    };

    const handleViewUser = (rowData) => {
        setDisplayDialog(true);
        setAddEditUser(true);
        setViewDisable(true);
        setUserRowData(rowData);
    };

    const onHide = () => {
        setDisplayDialog(false);
        setAddEditUser(false);
        setViewDisable(false);
    };

    const handleDialog = () => {
        setDisplayDialog(true);
    };

    const handleReferral = () => {
        setReferral(!referral);
        if (referral) { // If switching back to normal mode
            setIsSearchMode(false);
            getCustomersList(1, rowsPerPage);
        }
    };

    const normalizeUserData = (user) => {
        return {
            id: user.id || user.farmerId,
            email: user.email,
            name: user.name,
            urduName: user.urduName,
            phone: user.phone,
            cnic: user.cnic,
            referral: user.referral,
            createdAt: user.createdAt || user.createdDate,
            status: user.status || (user.isActive === 1 ? "Active" : "Inactive"),
            formDate: user.formDate || null,
            endDate: user.endDate || null,
            totalRequest: user.totalRequest || 0,
            completedRequest: user.completedRequest || 0,
            completedRequestRent: user.completedRequestRent || 0,
            pendingRequest: user.pendingRequest || 0,
            pendingRequestRent: user.pendingRequestRent || 0,
            profileImage: user.profileImage || user.farmerProfileImg
        };
    };

    const handleSearch = async (page = 1, limit = 20) => {
        setLoading(true);
        setIsSearchMode(true);
        
        // Ensure page and limit are numbers and handle 0-based indexing
        page = Math.max(parseInt(page) || 1, 1);
        limit = Math.max(parseInt(limit) || 20, 1);
        setCurrentPage(page - 1); // Convert to 0-based for DataTable
        setRowsPerPage(limit);
        
        // Build query parameters dynamically
        const params = new URLSearchParams();
        if (referralText.trim()) {
            params.append('referral', referralText.trim());
        }
        if (fromDate) {
            params.append('fromDate', moment(fromDate).format("DD-MM-YYYY"));
        }
        if (toDate) {
            params.append('toDate', moment(toDate).format("DD-MM-YYYY"));
        }
        params.append('page', page.toString());
        params.append('limit', limit.toString());
        
        const queryString = params.toString();
        const url = `/api/v1/farmer/stats${queryString ? '?' + queryString : ''}`;
        
        const response = await dispatch(handleGetRequest(url, true));
        console.log("API Response:", response);
        if (response?.statusCode === 200 || response?.status === 200) {
            // Ensure we have an array of data (API returns data array at response.data)
            const data = Array.isArray(response.data) ? response.data : [];
            const normalizedData = data.map(normalizeUserData);
            setAllUsers(normalizedData);

            // Get total count from the response
            let total = response.count;
            if (typeof total !== 'number') {
                total = response.total || response.pagination?.totalRecords || data.length;
            }
            // Ensure total is a valid number
            total = parseInt(total);
            setTotalRecords(isNaN(total) ? 0 : total);
            console.log('Pagination Debug:', {
                page,
                limit,
                total,
                currentPage: page - 1,
                dataLength: normalizedData.length
            });
        }
        setLoading(false);
    };

    const getCustomersList = async (page = 1, limit = 20) => {
        setLoading(true);
        setIsSearchMode(false);
        setCurrentPage(page - 1); // Convert to 0-based for DataTable
        
        // Ensure page and limit are numbers
        page = parseInt(page) || 1;
        limit = parseInt(limit) || 20;
        
        const response = await dispatch(handleGetRequest(`/api/v1/farmer/getAll?page=${page}&limit=${limit}`, true));
        if (response && (response.statusCode === 200 || response.status === 200)) {
            // API returns data array at response.data
            const data = Array.isArray(response.data) ? response.data : [];
            const normalizedData = data.map(normalizeUserData);
            setAllUsers(normalizedData);
            setTotalRecords(response.pagination?.totalRecords || data.length);
        }
        setLoading(false);
    };

    useEffect(() => {
        getCustomersList(1, rowsPerPage);
    }, []);

    const onPage = (event) => {
        const page = parseInt(event.page) + 1; // PrimeReact uses 0-based indexing
        const limit = parseInt(event.rows) || 20;
        setCurrentPage(event.page);
        setRowsPerPage(limit);
        
        if (isSearchMode) {
            handleSearch(page, limit);
        } else {
            getCustomersList(page, limit);
        }
    };

    const exportExcel = async () => {
        setLoading(true);
        try {
            // Build query parameters for filtered export
            const params = new URLSearchParams();
            if (referralText.trim()) {
                params.append('referral', referralText.trim());
            }
            if (fromDate) {
                params.append('fromDate', moment(fromDate).format("DD-MM-YYYY"));
            }
            if (toDate) {
                params.append('toDate', moment(toDate).format("DD-MM-YYYY"));
            }
            params.append('page', '1');
            params.append('limit', '10000'); // Large limit to get all filtered data

            // Use appropriate endpoint based on whether we're in filtered mode
            const queryString = params.toString();
            const url = referral
                ? `/api/v1/farmer/stats${queryString ? '?' + queryString : ''}`
                : `/api/v1/farmer/getAll?page=1&limit=10000${queryString ? '&' + queryString : ''}`;

            const response = await dispatch(handleGetRequest(url, true));

            if (response && (response.statusCode === 200 || response.status === 200)) {
                // Accept both response.data (array) and response.data.data (nested)
                const dataArray = Array.isArray(response.data)
                    ? response.data
                    : Array.isArray(response.data?.data)
                        ? response.data.data
                        : [];

                if (!dataArray.length) {
                    toast.info("No data available to export");
                    return;
                }

                const allData = dataArray.map(normalizeUserData);
                const dataToExport = allData.map((client) => ({
                    Name: client?.name || "N/A",
                    UrduName: client?.urduName || "N/A",
                    Email: client?.email || "N/A",
                    Contact: client?.phone || "N/A",
                    CNIC: client?.cnic || "N/A",
                    Referral: client?.referral || "N/A",
                    Status: client?.status || "N/A",
                    "Created Date": client?.createdAt ? moment(client.createdAt).format("DD-MM-YYYY") : "N/A",
                    "From Date": client?.formDate ? moment(client.formDate).format("DD-MM-YYYY") : "N/A",
                    "End Date": client?.endDate ? moment(client.endDate).format("DD-MM-YYYY") : "N/A",
                    "Total Request": client?.totalRequest || 0,
                    "Completed Request": client?.completedRequest || 0,
                    "Completed Request Rent": client?.completedRequestRent || 0,
                    "Pending Request": client?.pendingRequest || 0,
                    "Pending Request Rent": client?.pendingRequestRent || 0,
                }));

                const worksheet = XLSX.utils.json_to_sheet(dataToExport);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, "All Customers List");
                XLSX.writeFile(workbook, "AllClients.xlsx");
                toast.success("Exported Excel successfully");
            } else {
                toast.error("Failed to fetch data for export");
            }
        } catch (err) {
            console.error("Export error:", err);
            toast.error("An error occurred while exporting");
        } finally {
            setLoading(false);
        }
    };

    const imageTemplate = (rowData) => {
        // Always prefer farmerProfileImg if present, fallback to profileImage
        const imgSrc = rowData?.farmerProfileImg ? rowData.farmerProfileImg : rowData?.profileImage;
        return (
            <Image
                src={imgSrc ? `${baseURL}/${imgSrc}` : ''}
                zoomSrc={imgSrc ? `${baseURL}/${imgSrc}` : ''}
                alt="Image"
                preview
            />
        );
    };

    const Header = () => {
        return (
            <>
                <h3 className="pr-2 pl-2 text-center" style={{ fontWeight: "600" }}>
                    {addEditUser && !viewDisable
                        ? "Edit Customer"
                        : viewDisable && addEditUser
                            ? "View Details"
                            : "Add Customer"}
                </h3>
                <div className="mt-2">
                    <hr />
                </div>
            </>
        );
    };

    return (
        <>
            <Dialog
                draggable={false}
                resizable={false}
                header={Header}
                visible={displayDialog}
                style={{ width: "64vw" }}
                onHide={onHide}
            >
                <AddEditCustomer
                    onHide={onHide}
                    getCustomersList={getCustomersList}
                    addEditUser={addEditUser}
                    userRowData={userRowData}
                    viewDisable={viewDisable}
                />
            </Dialog>

            <div className="card dark-bg">
                <LoadingOverlay
                    active={loading}
                    spinner={
                        <Triangle
                            height="120"
                            width="120"
                            color="#798403"
                            ariaLabel="triangle-loading"
                            visible={true}
                        />
                    }
                    styles={{
                        overlay: (base) => ({
                            ...base,
                            background: "rgb(38 41 51 / 78%)",
                        }),
                    }}
                >
                    <DataTable
                        header={
                            <>
                                <div
                                    className="flex justify-content-between custom-alignment"
                                    style={{ display: "flex", alignItems: "center" }}
                                >
                                    <div>
                                        <span className="search-container">
                                            <i className={globalFilterValue ? "" : "pi pi-search search-icon"} />
                                            <InputText
                                                placeholder="Search"
                                                value={globalFilterValue}
                                                onChange={onGlobalFilterChange}
                                                className="search-input mb-3"
                                            />
                                        </span>
                                    </div>

                                    <div>
                                        <Button
                                            label="Search via Referral"
                                            className="Add__New-Button mb-2 mr-2"
                                            icon={referral ? "pi pi-arrow-up" : "pi pi-arrow-down"}
                                            onClick={handleReferral}
                                        />
                                        <Button
                                            label="Add New"
                                            className="Add__New-Button mb-2"
                                            icon="pi pi-plus"
                                            onClick={handleDialog}
                                        />
                                    </div>
                                </div>
                                {referral && (
                                    <div
                                        className="flex justify-content-between custom-alignment"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            borderBottom: "1px solid #ccc",
                                        }}
                                    >
                                        <div>
                                            <Button
                                                disabled={allUsers === undefined}
                                                label="Export Excel"
                                                className="Add__New-Button mb-2 mr-2"
                                                icon="pi pi-file-excel"
                                                onClick={exportExcel}
                                            />
                                        </div>
                                        <div id="date">
                                            <span className="search-constainer">
                                                <InputText
                                                    placeholder="Search via referral"
                                                    value={referralText}
                                                    onChange={(e) => setReferralText(e.target.value)}
                                                    className="search-input mb-3 mr-2"
                                                />
                                            </span>
                                            <Calendar
                                                placeholder="From Date"
                                                id="fromDate"
                                                className="mb-2 mr-2"
                                                value={fromDate}
                                                onChange={(e) => setFromDate(e.target.value)}
                                                showIcon
                                                maxDate={toDate || new Date()}
                                            />
                                            <Calendar
                                                placeholder="To Date"
                                                id="toDate"
                                                className="mb-2 mr-2"
                                                value={toDate}
                                                onChange={(e) => setToDate(e.target.value)}
                                                showIcon
                                                minDate={fromDate}
                                                maxDate={new Date()}
                                            />
                                            <Button
                                                label="Search"
                                                className="Add__New-Button mb-3"
                                                icon="pi pi-search"
                                                onClick={handleSearch}
                                            />
                                        </div>
                                    </div>
                                )}
                            </>
                        }
                        responsive={true}
                        filters={filters}
                        globalFilterFields={[
                            "name",
                            "cnic",
                            "urduName",
                            "phone",
                            "isActive",
                            "cnic",
                            "CreatedAt",
                            "referral",
                        ]}
                        responsiveLayout="scroll"
                        stripedRows
                        paginator
                        lazy
                        loading={loading}
                        first={currentPage * rowsPerPage}
                        rows={rowsPerPage}
                        totalRecords={totalRecords}
                        onPage={onPage}
                        value={allUsers}
                        emptyMessage="No records found"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                        paginator
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                        rowsPerPageOptions={[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]}
                    >
                        <Column body={imageTemplate} header="Profile Image" />
                        <Column field="name" header="Name" />
                        <Column field="urduName" header="Urdu Name" />
                        <Column field="referral" body={(rowData) => rowData?.referral || "N/A"} header="Referral" />
                        <Column field="phone" header="Contact No." />
                        <Column field="cnic" header="CNIC" />
                        <Column
                            field="createdAt"
                            body={(rowData) => moment(rowData?.createdAt).format("DD-MM-YYYY") || "N/A"}
                            header="Created At"
                        />
                        <Column
                            body={(rowData) => {
                                // Prefer status, fallback to isActive
                                let statusValue = rowData?.status !== undefined ? rowData.status : rowData?.isActive;
                                let isActive = false;
                                if (typeof statusValue === "boolean") {
                                    isActive = statusValue;
                                } else if (typeof statusValue === "string") {
                                    isActive = statusValue.trim().toLowerCase() === "active";
                                } else if (statusValue === 1) {
                                    isActive = true;
                                }
                                return (
                                    <Tag
                                        style={{ fontSize: "11px", padding: "3px 6px" }}
                                        value={isActive ? "Active" : "Inactive"}
                                        severity={isActive ? "success" : "danger"}
                                    />
                                );
                            }}
                            header="Status"
                        />
                        <Column
                            field="formDate"
                            body={(rowData) => rowData?.formDate
                                ? moment(rowData.formDate).format("DD-MM-YYYY")
                                : "N/A"}
                            header="From Date"
                        />

                        <Column
                            field="endDate"
                            body={(rowData) => rowData?.endDate
                                ? moment(rowData.endDate).format("DD-MM-YYYY")
                                : "N/A"}
                            header="End Date"
                        />
                        <Column field="totalRequest" body={(rowData) => rowData?.totalRequest || 0} header="Total Request" />
                        <Column field="completedRequest" body={(rowData) => rowData?.completedRequest || 0} header="Completed Request" />
                        <Column field="completedRequestRent" body={(rowData) => rowData?.completedRequestRent || 0} header="Completed Request Rent" />
                        <Column field="pendingRequest" body={(rowData) => rowData?.pendingRequest || 0} header="Pending Request" />
                        <Column field="pendingRequestRent" body={(rowData) => rowData?.pendingRequestRent || 0} header="Pending Request Rent" />
                        <Column header="Action" body={actionTemplate} />
                    </DataTable>
                </LoadingOverlay>
            </div>
        </>
    );
};

export default CustomerManagement;
